import { render, staticRenderFns } from "./SiteHeader2.vue?vue&type=template&id=5b755eda&comments=true&"
import script from "./SiteHeader2.vue?vue&type=script&lang=js&"
export * from "./SiteHeader2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports